import type { NavigationItem } from "@/app/layouts/navigation";
import type { Category } from "@/services/api/categories";
import { generateCategorySlug, getCategoryLabel } from "./categoryUtils";

export function getCategoriesNavigation(
  categories: Category[],
): NavigationItem[] {
  return categories.map((category) => {
    const label = getCategoryLabel(category);
    const abbr = label
      .split(/[\s/]/)
      .map((word) => word[0]?.toUpperCase() || "")
      .join("")
      .slice(0, 2);

    const slug = generateCategorySlug(category.name);

    return {
      id: `category-${category.id}`,
      label,
      abbr,
      description: category.description,
      icon: category.icon || undefined,
      target: {
        to: "/file-explorer/$categoryName",
        params: {
          categoryName: slug,
        },
      },
    };
  });
}
